import { WixService } from 'src/app/Services/Wix-Service/wix.service';
import { AfterViewInit, Component, ElementRef, EventEmitter, OnInit, Output, Renderer2, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { ConfirmationService, SelectItem } from "primeng/api";
import { FormBuilder, FormGroup } from "@angular/forms";
import { JwtHelperService } from "@auth0/angular-jwt";
import { FileUpload } from 'primeng/fileupload';
import { AngularEditorComponent, AngularEditorConfig } from "@kolkov/angular-editor";
import { ArtistsService } from "../../Services/artists.service";
import { ApplicationUser, AuthConfig, AuthService, ResponseObject } from "../../Services/auth.service";
import { NotificationsService } from "../../Services/shared/notifications.service";
import { CloudinaryImageService } from "../../Services/cloudinary-image.service";
import { ArtTypeService } from "../../Services/art-type.service";
import { UsersService } from "../../Services/users.service";
import { GalleriesService, GalleryAddress, GalleryDocumentSectionEnum, GalleryItems, GalleryTermsData, UserDocumentDTOs, AttachDocumentRequest } from "../../Services/galleries.service";
import { RegistrationsService, Cities, Countries, States } from "src/app/Services/registration.service";
import { AddressSuggestion } from "src/app/Services/mapbox-address.service";
import { ShopifyService, ShopifyOAuthToken } from "src/app/Services/shopify-service/shopify.service";
import { SquareupPosService, SquareUpOAuthTokken } from "src/app/Services/squareup-pos.service.ts/squareup-pos.service";
import { WoocomerceService, WoocommerceCredentials } from "src/app/Services/woocomerce-service/woocomerce.service";
import { StripeService } from "src/app/Services/stripe.service";
import { ArtistPortfolioProductsService, portfolioData, SaveFavoratePortfolioRequest } from 'src/app/Services/artist-portfolio-products/artist-portfolio-products.service';
import { SquareSpaceService } from 'src/app/Services/square-space/square-space.service';
// Models and enums
import { NotificationTypes } from "../../app.enums";
import { AppSettings } from "../../app.settings";
import { ArtFlowSelectItem } from "../../models/artflow.selectitem";
import { ArtistBankingInformation } from "../../Services/users.service";
import { SaveGalleryStaffRequest } from "src/app/models/staff.model";
import { StripePlans } from "src/app/models/stripe.model";
// Component imports
import { ShopifyAccount } from 'src/app/components/gallery-components/shopify-account/shopify-account.component';
import { ConnectWoocommerceAccountComponent } from 'src/app/components/gallery-components/connect-woocommerce-account/connect-woocommerce-account.component';
import { ImageCroppedResponse } from '../image-cropper/image-cropper.component';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-editprofile',
    templateUrl: './editprofile.component.html',
    styleUrls: ['./editprofile.component.css'],
    standalone: false
})
export class EditprofileComponent implements OnInit, AfterViewInit {

  // ViewChild decorators for child components and template references
  @ViewChild(ShopifyAccount, { static: false }) shopifyComponent: ShopifyAccount | undefined;
  @ViewChild(ConnectWoocommerceAccountComponent, { static: false }) woocommerceComponent: ConnectWoocommerceAccountComponent | undefined;
  @ViewChild('additionalFileUploadCmp') additionalFileUploadCmp!: FileUpload;
  @ViewChild('fileInput') fileInput!: ElementRef;

  // Angular Editor ViewChild references
  @ViewChild('paymentTermsEditorConfig') paymentTermsEditor!: AngularEditorComponent;
  @ViewChild('refundPolicyEditor') refundPolicyEditor!: AngularEditorComponent;
  @ViewChild('termsConditionsEditor') termsConditionsEditor!: AngularEditorComponent;

  // File upload ViewChild references
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  @ViewChild('paymentTermsFileUpload') paymentTermsFileUpload!: FileUpload;
  @ViewChild('returnPolicyFileUpload') returnPolicyFileUpload!: FileUpload;
  @ViewChild('termsConditionsFileUpload') termsConditionsFileUpload!: FileUpload;

  // Image cropper properties
  public enableCropper: boolean = true;
  public currentSelectedImageToCrop?: File;
  public showCropperDialog: boolean = false;
  public selectedFile!: File;
  public imgType: string = ''; // Stores the image type (e.g., 'ArtistImg' or 'BusinessLogo')

  // File upload properties
  public additionalFiles: any[] = [];
  public documents: UserDocumentDTOs[] = [];
  public selectedFiles: { [key: string]: string } = {};
  public isUploading: boolean = false;
  public profileLoaded: boolean = false;
  public isRenameDialogVisible: boolean = false;
  public documentToRename: any = null;
  public newDocumentName: string = '';

  // Form and user data properties
  public formData: ApplicationUser = {} as ApplicationUser;
  public requestData: ResetPassword = {} as ResetPassword;
  public staffFormsData: SaveGalleryStaffRequest = {} as SaveGalleryStaffRequest;
  public bankingFormData: ArtistBankingInformation = {};
  public userId!: string;
  public loginUserId!: string;
  public uploader!: FormGroup;

  // Authentication and authorization properties
  public authConfig: AuthConfig = {};
  public isArtist: boolean | undefined = false;
  public isGallery: boolean | undefined = false;
  public isGalleryStaff: boolean = false; // GalleryStaff (Judge/Curator)
  public isEventArtist: boolean = false; // Event-only artist (registered via event)

  // Plan and subscription properties
  public isFreePlanUser: boolean = true;
  public hasFreeTrailEnded: boolean | undefined;
  public isOnFreeTrial!: boolean;
  public numberOfArtTypeSelection!: number;
  public stripePlans: StripePlans[] = [];
  public upgradeDialogVisible = false;

  // Dialog visibility flags
  public isPasswordConfirmationDailogVisible: boolean = false;
  public isBankingInformtionDailogVisible: boolean = false;
  public isStripeDisplayPlansDialogVisible: boolean = false;
  public isShopifyConnectionDailogVisible: boolean = false;
  public isAddWoocommerceAccountDailogVisible: boolean = false;
  public showportfoliosproductsdialog: boolean = false;
  public showShareDialog: boolean = false;
  public staffDailogVisible: boolean = false;
  public artTypeDialogVisible = false;
  public galleryArtTypeDialogVisible = false;

  // Location properties
  public selectedGalleryAddress!: GalleryAddress;
  public countries: Countries[] = [];
  public states: States[] = [];
  public cities: Cities[] = [];
  public selectedCountry!: string;
  public selectedState!: string;
  public selectedCity!: string;
  public countrySelect!: string;
  public stateSelect!: string;
  public selectedCountryId!: any;
  public selectedStateId!: any;
  public selectedCityId!: any;
  public selectedCountryName!: string;
  public selectedStateName!: string;
  public selectedCityName!: string;

  // Art type properties
  public artTypes: ArtFlowSelectItem[] = [];
  public selectedArtTypes: string[] = [];
  public galleryArtTypes: ArtFlowSelectItem[] = [];
  public selectedGalleryArtTypes: string[] = [];
  public selectedArtType: string = '';

  // Gallery properties
  public galleries: GalleryItems[] = [];
  public Staff: SaveGalleryStaffRequest[] = [];
  public formgalleryData: GalleryItems = {} as GalleryItems;
  public galleryItems = new GalleryItems();

  // Third-party service integration properties
  public shopifyAccount: ShopifyOAuthToken = {} as ShopifyOAuthToken;
  public squareUpAccount: SquareUpOAuthTokken = {} as SquareUpOAuthTokken;
  public wooCommerceAccount: WoocommerceCredentials = {} as WoocommerceCredentials;
  public woocommerceFormData: WoocommerceCredentials = {} as WoocommerceCredentials;
  public isSquarePos!: boolean;
  public isShopify!: boolean;
  public isWoocommerce!: boolean;
  public isWix!: boolean;
  public isSquareSpace!: boolean;
  public checkAccountExitsOnWix: boolean = false;
  public wixAccountConnectedDate: string = '';
  public wixConnectAccount: boolean = false;
  public squareSpaceAccountExists: boolean = false;

  // Portfolio properties
  public portfolioDropdownOptions: portfolioData[] = [];
  public portfolioSelections: string[] = ['', '', '']; // Array to store selected portfolio IDs
  public portfolioSelection1: SaveFavoratePortfolioRequest = {} as SaveFavoratePortfolioRequest;
  public portfolioSelection2: SaveFavoratePortfolioRequest = {} as SaveFavoratePortfolioRequest;
  public portfolioSelection3: SaveFavoratePortfolioRequest = {} as SaveFavoratePortfolioRequest;
  public selectedPortfolioId: string = '';

  // UI state properties
  public isEditMode: boolean = false;
  public hidelable: boolean = true;
  public staffLoading: boolean = false;
  public storeUrl: string = '';
  public isSentByEditProfile: boolean = true;
  public showBusinessNameError: boolean = false;
  public activeIndex: number = 0;

  // Configuration arrays
  public items: string[] = ['Artist', 'Manafacture', 'Public Gallery', 'Exhibition space', 'Charity', 'Government Organization', 'Other'];
  public commissionOptions: { value: number; label: string }[] = [];
  public terms: string[] = ['3 Days', '7 Days', '30 Days'];
  public selectCurrency: SelectItem[] = [];

  // Constants
  public secret_key: string = '!@#$%^&*(';

  // Editor configurations
  public editorConfig: AngularEditorConfig = {
    outline: true,
    rawPaste: true,
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '150px',
    toolbarHiddenButtons: [
      ['undo', 'redo', 'strikeThrough', 'subscript', 'superscript', 'justifyFull', 'indent', 'outdent', 'heading', 'fontName'],
      ['fontSize', 'textColor', 'backgroundColor', 'customClasses', 'insertImage', 'insertVideo', 'insertHorizontalRule', 'removeFormat']
    ],
  };

  public resumeEditorConfig: AngularEditorConfig = {
    outline: true,
    rawPaste: true,
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '460px',
    toolbarHiddenButtons: [
      ['undo', 'redo', 'strikeThrough', 'subscript', 'superscript', 'justifyFull', 'indent', 'outdent', 'heading', 'fontName'],
      ['fontSize', 'textColor', 'backgroundColor', 'customClasses', 'insertImage', 'insertVideo', 'insertHorizontalRule', 'removeFormat']
    ],
  };

  paymentTermsEditorConfig: AngularEditorConfig = {
    outline: true,
    rawPaste: true,
    editable: true,
    spellcheck: true,
    enableToolbar: true,
    height: 'auto',
    minHeight: '150px',
    toolbarHiddenButtons: [
      ['strikeThrough', 'subscript', 'superscript', 'justifyFull', 'indent', 'outdent', 'heading'],
      ['customClasses', 'insertVideo', 'insertHorizontalRule', 'removeFormat']
    ]
  };

  public returnPolicyEditorConfig: AngularEditorConfig = {
    outline: true,
    rawPaste: true,
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '150px',
    toolbarHiddenButtons: [
      ['undo', 'redo', 'strikeThrough', 'subscript', 'superscript', 'justifyFull', 'indent', 'outdent', 'heading', 'fontName'],
      ['fontSize', 'textColor', 'backgroundColor', 'customClasses', 'insertImage', 'insertVideo', 'insertHorizontalRule', 'removeFormat']
    ],
  };

  public termsConditionsEditorConfig: AngularEditorConfig = {
    outline: true,
    rawPaste: true,
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '150px',
    toolbarHiddenButtons: [
      ['undo', 'redo', 'strikeThrough', 'subscript', 'superscript', 'justifyFull', 'indent', 'outdent', 'heading', 'fontName'],
      ['fontSize', 'textColor', 'backgroundColor', 'customClasses', 'insertImage', 'insertVideo', 'insertHorizontalRule', 'removeFormat']
    ],
  };

  // Constructor to initialize services and form data
  constructor(
    private router: Router,
    private authService: AuthService,
    private uploadService: CloudinaryImageService,
    private confirmationService: ConfirmationService,
    private ngxSpinnerService: NgxSpinnerService,
    private squareupPosService: SquareupPosService,
    private notificationsService: NotificationsService,
    private usersService: UsersService,
    private shopifyService: ShopifyService,
    private squareService: SquareupPosService,
    private wixService: WixService,
    private wooCommerceService: WoocomerceService,
    private artistsService: ArtistsService,
    private artTypeService: ArtTypeService,
    private galleriesService: GalleriesService,
    private artistPortfolioProductsService: ArtistPortfolioProductsService,
    private squareSpaceService: SquareSpaceService,
    private fb: FormBuilder,
    private stripeService: StripeService,
    private registrationsService: RegistrationsService,
    private jwtHelper: JwtHelperService,
    private renderer: Renderer2,
    private transloco: TranslocoService
  ) {
    // Initialize form data and configurations
    this.formData = new ApplicationUser();
    this.staffFormsData = new SaveGalleryStaffRequest();
    this.uploader = this.fb.group({
      file: [null],
    });
    this.selectedGalleryAddress = new GalleryAddress();
    this.galleryItems.GallerySaleType = 'Consignment';
    if (this.formData.Gallery) {
      this.formData.Gallery.GalleryType = 'Consignment';
    }
    // Generate commission options from 5% to 90% with a step of 5%
    for (let i = 5; i <= 90; i += 5) {
      this.commissionOptions.push({ value: i, label: `${i}%` });
    }
  }

  ngAfterViewInit() {
    // Log initialization of text editors
    if (this.paymentTermsEditor) {
      console.log('Payment Terms Editor initialized:', this.paymentTermsEditor);
    }
    if (this.refundPolicyEditor) {
      console.log('Refund Policy Editor initialized:', this.refundPolicyEditor);
    }
    if (this.termsConditionsEditor) {
      console.log('Terms & Conditions Editor initialized:', this.termsConditionsEditor);
    }
  }

  // Initialize component with user data and configurations
  ngOnInit(): void {
    this.userId = this.authService.getUserId();
    console.log("✅ userId:", this.userId);

    this.authConfig = this.authService.getAuthConfig();
    this.isGallery = this.authConfig.IsGallery;
    this.isArtist = this.authConfig.IsArtist;
    this.isGalleryStaff = this.authService.isGalleryStaff(); // Check if GalleryStaff (Judge/Curator)
    this.isEventArtist = this.authService.isEventArtist(); // Check if event-only artist
    this.isFreePlanUser = this.authService.isFreePlanUser();
    console.log("✅ isFreePlanUser:", this.isFreePlanUser);

    this.hasFreeTrailEnded = this.authService.hasFreeTrialEnded();
    console.log("✅ hasFreeTrialEnded:", this.hasFreeTrailEnded);

    this.isOnFreeTrial = this.authService.isOnFreetrial();
    console.log("✅ isOnFreeTrial:", this.isOnFreeTrial);

    this.numberOfArtTypeSelection = this.authService.getArtTypeSelection();
    console.log(" numberOfArtTypeSelection:", this.numberOfArtTypeSelection);

    this.isSquarePos = this.authService.IsSquarePOS();
    console.log(" isSquarePos:", this.isSquarePos);

    this.isShopify = this.authService.IsShopify();
    console.log(" isShopify:", this.isShopify);

    this.isWoocommerce = this.authService.IsWoocommerce();
    console.log(" isWoocommerce:", this.isWoocommerce);

    this.isWix = this.authService.IsWix();
    console.log(" isWix:", this.isWix);

    this.isSquareSpace = this.authService.IsSquareSpace();
    console.log("IsSquareSpace", this.isSquareSpace);

    // Fetch data for Artist or Gallery roles
    if (this.authConfig.IsArtist || this.authConfig.IsGallery) {
      this.getArtTypes();
      this.getPortFolioData();
      this.HasAccountOnShopify();
      this.HasAccountOnWooCommerce();
      this.hasSquareSpaceAccount();
      this.fetchCountries();
    }

    // Fetch gallery-specific data
    if (this.authConfig.IsGallery) {
      this.getGalleryById(this.userId);
      this.getSelectedGalleryArtTypes();
      this.HasAccountOnSquareUp();
      this.hasAccountOnWix();
    }

    // Fetch artist-specific data
    if (this.authConfig.IsArtist) {
      this.getArtistArtTypes();
    }

    // Fetch basic data for GalleryStaff (Judge/Curator)
    if (this.isGalleryStaff) {
      this.fetchCountries();
    }

    // Initialize currency options
    this.getUserById();
    this.selectCurrency.push({ label: '--Select Currency--', value: '' });
    this.selectCurrency.push({ label: 'Pakistan (Rupee)', value: 'PKR' });
    this.selectCurrency.push({ label: 'US(Dollar)', value: 'USD' });
    this.selectCurrency.push({ label: 'Euro', value: 'EUR' });
    this.selectCurrency.push({ label: 'Australia (Dollar)', value: 'AUD' });
    this.selectCurrency.push({ label: 'Canada (Dollar)', value: 'CAD' });
    this.selectCurrency.push({ label: 'Yuan Renminbi', value: 'CNY' });
    this.selectCurrency.push({ label: 'Indian (rupee)', value: 'INR' });
    this.selectCurrency.push({ label: 'Ruble', value: 'RUB' });
    this.selectCurrency.push({ label: 'Riyal', value: 'SAR' });
    this.selectCurrency.push({ label: 'Lira', value: 'TRL' });
  }

  public onCurrencyChanged($event: any) {
    this.formData.CurrencyCode = $event.value;
  }

  public showDailog() {
    this.staffDailogVisible = true;
    this.isEditMode = false;
  }

  public closeDialog() {
    this.staffDailogVisible = false;
    this.staffFormsData = {} as SaveGalleryStaffRequest;
  }

  public onCancel() {
    this.staffDailogVisible = false;
  }

  // Handle file selection for image upload
  public onFileSelected(files: File[], imgType: string) {
    this.selectedFile = files[0];
    console.log(this.selectedFile);
    this.imgType = imgType;

    const isImage = this.selectedFile && this.selectedFile.type.includes('image');
    if (!isImage) {
      console.log('Selected file is not an image');
      return;
    }

    if (imgType === 'PrimaryProductImageUrl') {
      this.uploadImage(this.selectedFile, imgType);
    } else {
      this.showCropperDialog = true;
      this.currentSelectedImageToCrop = this.selectedFile;
    }
  }

  // Handle cropped image
  public onImageCropped(croppedImage: ImageCroppedResponse) {
    console.log(croppedImage);
    this.selectedFile = croppedImage.CroppedImage;
    this.uploadImage(this.selectedFile, this.imgType);
    this.showCropperDialog = false;
  }

  public onImageCropperClose($event: any) {
    if ($event.skipCropping) {
      this.selectedFile = null!;
      this.showCropperDialog = false;
      if (this.fileUpload) {
        this.fileUpload.clear();
      }
    }
  }

  // Upload image to the server
  public uploadImage(file: File, value: string) {
    if (!file) return;

    const formData = new FormData();
    formData.append('ImageFile', file);
    this.ngxSpinnerService.show();

    if (value === 'ArtistImg') {
      this.uploadService.uploadImage(formData).subscribe(
        (imageUrl: string) => {
          this.formData.ImgUrl = imageUrl;
          this.ngxSpinnerService.hide();
          console.log('Updated ImgUrl:', this.formData.ImgUrl);
        },
        (error) => {
          console.error(error);
          this.ngxSpinnerService.hide();
        }
      );
    } else if (value === 'BusinessLogo') {
      this.uploadService.uploadImage(formData).subscribe(
        (imageUrl: string) => {
          this.formData.BusinessLogoUrl = imageUrl;
          this.ngxSpinnerService.hide();
          console.log('Updated BusinessLogoUrl:', this.formData.BusinessLogoUrl);
        },
        (error) => {
          console.error(error);
          this.ngxSpinnerService.hide();
        }
      );
    } else if (value === 'PrimaryProductImageUrl') {
      this.uploadService.uploadImage(formData).subscribe(
        (imageUrl: string) => {
          this.formData.PrimaryProductImageUrl = imageUrl;
          this.ngxSpinnerService.hide();
          console.log('Updated PrimaryProductImageUrl:', this.formData.PrimaryProductImageUrl);
        },
        (error) => {
          console.error(error);
          this.ngxSpinnerService.hide();
        }
      );
    }
  }

  public removeImg(value: string) {
    if (value == 'ArtistImg') {
      this.formData.ImgUrl = null!;
    } else if (value == 'BusinessLogo') {
      this.formData.BusinessLogoUrl = null!;
    } else if (value == 'PrimaryProductImageUrl') {
      this.formData.PrimaryProductImageUrl = null!;
    }
  }

  public editGalleryAddress(event: any) {
    this.galleryItems.GalleryAddresses = event;
  }

  // Update user profile
  public updateProfile() {
    this.showBusinessNameError = false;
    // Skip business name validation for GalleryStaff (Judge/Curator)
    if (this.isGallery && !this.isGalleryStaff && !this.formData.BusinessName) {
      this.showBusinessNameError = true;
      return;
    }
    this.isBankingInformtionDailogVisible = false;
    this.formData.ArtistArtTypes = this.selectedArtTypes.filter(
      id => id !== this.formData.PrimaryArtTypeId
    );
    this.ngxSpinnerService.show();
    this.usersService.updateUser(this.formData.Id, this.formData).subscribe(
      (response: ResponseObject) => {
        this.ngxSpinnerService.hide();
        if (response.Success) {
          this.getGalleryById(this.userId);
          this.notificationsService.showNotification(this.transloco.translate('editprofile.success'), this.transloco.translate('editprofile.changesSaved'), NotificationTypes.Success);
        } else {
          this.notificationsService.showNotification(this.transloco.translate('editprofile.error'), response.ResponseMessage, NotificationTypes.Error);
        }
      },
      (error) => {
        console.error(error);
        this.ngxSpinnerService.hide();
      }
    );
  }

  // Check if user has Shopify account
  private HasAccountOnShopify() {
    this.shopifyService.hasAccountOnShopify().subscribe(
      (accountExists: ShopifyOAuthToken) => {
        this.shopifyAccount = accountExists;
        console.log('shopifyAccount', this.shopifyAccount);
      },
      (error) => {
        console.error(error);
      }
    );
  }

  // Check if user has SquareUp account
  private HasAccountOnSquareUp() {
    this.squareService.hasAccountOnSquareUp().subscribe(
      (accountExists: SquareUpOAuthTokken) => {
        this.squareUpAccount = accountExists;
        console.log('squareUpAccount', accountExists);
      },
      (error) => {
        console.error(error);
      }
    );
  }

  // Check if user has WooCommerce account
  private HasAccountOnWooCommerce() {
    this.wooCommerceService.hasAccountOnWooCommerce().subscribe(
      (accountExists: WoocommerceCredentials) => {
        this.wooCommerceAccount = accountExists;
        console.log('wooCommerceAccount', accountExists);
      },
      (error) => {
        console.error(error);
      }
    );
  }

  private hasSquareSpaceAccount() {
    this.squareSpaceService.hasAccountOnSquareSpace().subscribe(response => {
      if (response.Success) {
        this.squareSpaceAccountExists = true;
      } else {
        this.squareSpaceAccountExists = false;
      }
    });
  }

  public onShowWoocommerceAccountDailog() {
    this.isAddWoocommerceAccountDailogVisible = true;
  }

  public onCloseWoocommerceAccountDailog($event: boolean) {
    this.isAddWoocommerceAccountDailogVisible = $event;
  }

  // Fetch artist banking information
  public getArtistBankingInfo() {
    this.isPasswordConfirmationDailogVisible = true;
    this.ngxSpinnerService.show();
    this.usersService.getArtistBankingInfo(this.formData.Password).subscribe(
      (response: ResponseObject) => {
        this.ngxSpinnerService.hide();
        if (response.Success) {
          this.formData.Password = '';
          this.isPasswordConfirmationDailogVisible = false;
          this.isBankingInformtionDailogVisible = true;
          var artistBankingInfo: ArtistBankingInformation = response.ResponseData;
          this.bankingFormData = artistBankingInfo;
          this.notificationsService.showNotification(this.transloco.translate('editprofile.success'), response.ResponseMessage, NotificationTypes.Success);
        } else {
          this.notificationsService.showNotification(this.transloco.translate('editprofile.error'), response.ResponseMessage, NotificationTypes.Error);
        }
      },
      (error) => {
        console.error(error);
        this.ngxSpinnerService.hide();
      }
    );
  }

  public updateArtistBankingInformation() {
    this.ngxSpinnerService.show();
    this.usersService.updateArtistBankingInformation(this.bankingFormData).subscribe(
      (response: ResponseObject) => {
        this.ngxSpinnerService.hide();
        if (response.Success) {
          this.notificationsService.showNotification(this.transloco.translate('editprofile.success'), this.transloco.translate('editprofile.changesSaved'), NotificationTypes.Success);
        } else {
          this.notificationsService.showNotification(this.transloco.translate('editprofile.error'), response.ResponseMessage, NotificationTypes.Error);
        }
      },
      (error) => {
        console.error(error);
        this.ngxSpinnerService.hide();
      }
    );
  }

  // Reset user password
  public resetPassword() {
    if (this.isPasswordMismatch()) {
      console.log('Passwords do not match');
      return;
    }

    this.ngxSpinnerService.show();
    this.requestData.UserId = this.userId;
    this.authService.resetPassword(this.requestData).subscribe(
      (response) => {
        this.ngxSpinnerService.hide();
        if (response.Success) {
          this.notificationsService.showNotification(this.transloco.translate('editprofile.success'), response.ResponseMessage, NotificationTypes.Success);
          localStorage.removeItem(AppSettings.ACCESS_TOKEN || AppSettings.AUTH_USER);
          window.location.reload();
          this.router.navigate(['login']);
        } else {
          this.notificationsService.showNotification(this.transloco.translate('editprofile.error'), response.ResponseMessage, NotificationTypes.Error);
        }
      },
      (error) => {
        console.error('Error resetting password:', error);
      }
    );
  }

  public isPasswordMismatch(): boolean {
    return this.requestData.NewPassword !== this.requestData.ConfirmPassword;
  }

  // Fetch available art types
  private getArtTypes() {
    var filterRoleBasedArttypes = false;
    this.artTypeService.fetch(filterRoleBasedArttypes).subscribe(
      (artTypeItems) => {
        this.artTypes = artTypeItems.map((item) => {
          return { label: item.Name, value: item.Id, selected: false };
        });
      },
      (error) => {
        console.error(error);
      }
    );
  }

  private getArtistArtTypes() {
    this.artistsService.getArtistArtTypes().subscribe(
      (artistArttypeIds: string[]) => {
        this.selectedArtTypes = artistArttypeIds;
      },
      (error) => {
        console.error(error);
      }
    );
  }

  public openSelectArtTypeDialog() {
    this.artTypes.filter(p => this.selectedArtTypes.indexOf(p.value) >= 0).forEach(p => p.selected = true);
    this.artTypeDialogVisible = true;
  }

  public onApplySelectedArtTypes($event: any) {
    const selectedCount = this.artTypes.filter((p) => p.selected).length;
    if (this.isFreePlanUser && (this.hasFreeTrailEnded || !this.isOnFreeTrial) && selectedCount > this.numberOfArtTypeSelection) {
      this.upgradeDialogVisible = true;
      this.artTypeDialogVisible = false;
    } else {
      this.selectedArtTypes = this.artTypes
        .filter((p) => p.selected)
        .map((p) => p.value);
      this.artTypeDialogVisible = false;
    }
  }

  public onArtTypeChange(event: any): void {
    const selectedCount = this.selectedArtTypes.length;
    if (this.isFreePlanUser && (this.hasFreeTrailEnded || !this.isOnFreeTrial) && selectedCount > this.numberOfArtTypeSelection) {
      this.selectedArtTypes.pop();
      this.upgradeDialogVisible = true;
    }
  }

  public onUpgradePlan() {
    this.isStripeDisplayPlansDialogVisible = true;
  }

  public onCloseStripePaymentDailog($event: boolean) {
    this.isStripeDisplayPlansDialogVisible = $event;
  }

  public handleDialogClose(event: any) {
    this.upgradeDialogVisible = false;
  }

  public onShowConfirmationDailog() {
    this.isPasswordConfirmationDailogVisible = true;
  }

  public onCloseConfirmationDailog() {
    this.isPasswordConfirmationDailogVisible = false;
    this.formData.Password = '';
  }

  public onCloseBankingInformationDailog() {
    this.isBankingInformtionDailogVisible = false;
  }

  // Fetch countries for address selection
  private fetchCountries(): void {
    this.registrationsService.getAllCountries().subscribe(
      (countries: Countries[]) => {
        this.countries = countries;
        console.log('Fetched countries:', this.countries);
      },
      (error) => {
        console.error('Error fetching countries:', error);
      }
    );
  }

  private fetchStates(countryId: any): void {
    this.registrationsService.getAllStates(countryId).subscribe(
      (states: States[]) => {
        this.states = states;
        console.log("Fetched states:", this.states);
        if (this.formData.State) {
          const selectedState = this.states.find(
            (state) => state.name === this.formData.State
          );
          if (selectedState) {
            this.formData.State = selectedState.name;
          }
        }
      },
      (error) => {
        console.error("Error fetching states:", error);
      }
    );
  }

  private fetchCities(stateId: any): void {
    this.registrationsService.getAllCities(stateId).subscribe(
      (cities: Cities[]) => {
        this.cities = cities;
        console.log('Fetched cities:', this.cities);
      },
      (error) => {
        console.error('Error fetching cities:', error);
      }
    );
  }

  public onCountryChange(event: any): void {
    const selectedCountryName = event.target.value;
    this.formData.Country = selectedCountryName;
    this.formData.State = '';
    this.formData.City = '';
    this.states = [];
    this.cities = [];

    const selectedCountry = this.countries.find((c) => c.name === selectedCountryName);
    if (selectedCountry && selectedCountry.id) {
      this.fetchStates(selectedCountry.id);
    } else {
      console.error('Selected country not found or missing ID');
    }
  }

  public onStateChange(event: any): void {
    const selectedStateName = event.target.value;
    this.formData.State = selectedStateName;
    this.formData.City = '';
    this.cities = [];

    const selectedState = this.states.find((s) => s.name === selectedStateName);
    if (selectedState) {
      this.fetchCities(selectedState.id);
    }
  }

  public onCityChange(event: any): void {
    const selectedCityName = event.target.value;
    this.formData.City = selectedCityName;
  }

  /**
   * Fill the address fields from a Mapbox suggestion. Only overwrites a field when the
   * suggestion provides it, so a partial match never wipes existing free-text values.
   */
  public onAddressSelected(a: AddressSuggestion): void {
    if (a.country) this.formData.Country = a.country;
    if (a.state) this.formData.State = a.state;
    if (a.city) this.formData.City = a.city;
    if (a.suburb) this.formData.Suburb = a.suburb;
    if (a.postalCode) this.formData.PostCode = a.postalCode;
  }

  public onShowShopifyConnectionDailog() {
    this.isShopifyConnectionDailogVisible = true;
  }

  public onCloseShopifyConnectionDailog($event: boolean) {
    this.isShopifyConnectionDailogVisible = $event;
  }

  public onConnectShopifyAccount(): void {
    if (this.authConfig.IsGallery) {
      if (this.shopifyComponent) {
        console.log('Calling connect method from shopifyComponent');
        this.shopifyComponent.ConnectWithShopifyAccount();
      } else {
        console.error('shopifyComponent is not available yet!');
      }
    }
  }

  public connecWoocommerceAccount() {
    if (this.woocommerceComponent) {
      console.log('Calling connect method from WoocomerceComponent', this.woocommerceFormData);
      this.woocommerceComponent.connecWoocommerceAccount();
    } else {
      console.error('WoocomerceComponent is not available yet!');
    }
  }

  public hasAccountOnWix(): void {
    this.wixService.hasAccountOnWix().subscribe(
      (res) => {
        if (res.Success) {
          const accountExists = res.Success;
          this.wixAccountConnectedDate = res.ResponseData;
          console.log('Wix account exists:', accountExists);
          this.checkAccountExitsOnWix = accountExists;
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }

  public onViewSquarePosAccount() {
    this.router.navigate(['/connect-squareup-pos-account']);
  }

  public onViewShopifyAccount() {
    this.router.navigate(['/connect-with-shopify-account']);
  }

  public onViewWoocomerceAccount() {
    this.router.navigate(['/connect-with-woocommerce-account']);
  }

  public onViewWixAccount() {
    this.router.navigate(['/connect-with-wix-account']);
  }

  public onViewSquareSpaceAccount() {
    this.router.navigate(['/connect-with-squarespace-account']);
  }

  public onViewPublicProfile() {
  let username: string | null = null;

  if (this.authConfig.IsArtist && this.formData.UserName) {
    username = this.formData.UserName;
  } else if (this.authConfig.IsGallery && this.formData.UserName) {
    username = this.formData.UserName;
  }

  if (username) {
    this.router.navigate(['/profile', username]);
  } else {
    console.warn('Username not available for public profile');
  }
}

  // public onViewPublicProfile() {
  //   if (this.authConfig.IsArtist && this.formData.UserName) {
  //     const userName = this.formData.UserName;
  //     this.router.navigate(['/profile', userName]);
  //   } else if (this.authConfig.IsGallery && this.formData.Id) {
  //     this.router.navigate(['/view-gallery-profile', this.formData.Id]);
  //   }
  // }

  // Fetch user details
  private getUserById() {
    this.ngxSpinnerService.show();
    this.usersService.getUserDetails().subscribe(
      (res) => {
        this.formData = res;
        this.formData.WixPluginKeyIsActive = !!this.formData.PluginKey;
        if (this.formData.Country) {
          const selectedCountry = this.countries.find((c) => c.name === this.formData.Country);
          if (selectedCountry) {
            this.fetchStates(selectedCountry.id);
          }
        }
        if (this.formData.State) {
          const selectedState = this.states.find((s) => s.name === this.formData.State);
          if (selectedState) {
            this.fetchCities(selectedState.id);
          }
        }
        console.log("detail", this.formData);
        // FavouritePortfolioLinks may have fewer than 3 entries — guard each index.
        const favPortfolioLinks = res.FavouritePortfolioLinks || [];
        this.portfolioSelection1.portfolioLinkId = favPortfolioLinks[0] ? (this.portfolioDropdownOptions.find((portfolio) => portfolio.Id === favPortfolioLinks[0].PortfolioLinkId)?.Id || '') : '';
        this.portfolioSelection2.portfolioLinkId = favPortfolioLinks[1] ? (this.portfolioDropdownOptions.find((portfolio) => portfolio.Id === favPortfolioLinks[1].PortfolioLinkId)?.Id || '') : '';
        this.portfolioSelection3.portfolioLinkId = favPortfolioLinks[2] ? (this.portfolioDropdownOptions.find((portfolio) => portfolio.Id === favPortfolioLinks[2].PortfolioLinkId)?.Id || '') : '';
        if (this.portfolioSelection1.portfolioLinkId) {
          this.portfolioSelection1.title = res.FavouritePortfolioLinks[0].Title;
          this.portfolioSelection1.description = res.FavouritePortfolioLinks[0].Description;
          this.portfolioSelection1.isShow = res.FavouritePortfolioLinks[0].IsShow;
          console.log('isShow1', this.portfolioSelection1.isShow);
        }
        if (this.portfolioSelection2.portfolioLinkId) {
          this.portfolioSelection2.title = res.FavouritePortfolioLinks[1].Title;
          this.portfolioSelection2.description = res.FavouritePortfolioLinks[1].Description;
          this.portfolioSelection2.isShow = res.FavouritePortfolioLinks[1].IsShow;
          console.log('isShow2', this.portfolioSelection2.isShow);
        }
        if (this.portfolioSelection3.portfolioLinkId) {
          this.portfolioSelection3.title = res.FavouritePortfolioLinks[2].Title;
          this.portfolioSelection3.description = res.FavouritePortfolioLinks[2].Description;
          this.portfolioSelection3.isShow = res.FavouritePortfolioLinks[2].IsShow;
          console.log('isShow3', this.portfolioSelection3.isShow);
        }
        console.log("portfolioSelection", this.formData);
        if (this.formData.State) {
          const selectedState = this.states.find(
            (state) => state.name === this.formData.State
          );
          if (selectedState) {
            this.fetchCities(selectedState.id);
          }
        }
        this.profileLoaded = true;
        this.ngxSpinnerService.hide();
      },
      (error) => {
        console.error('Error fetching the logged-in user: ', error);
        this.ngxSpinnerService.hide();
      }
    );
  }

  // Fetch portfolio data
  public getPortFolioData(): void {
    this.ngxSpinnerService.show();
    this.artistPortfolioProductsService.getPortFolioData().subscribe({
      next: (portfolios: portfolioData[]) => {
        this.ngxSpinnerService.hide();
        this.portfolioDropdownOptions = portfolios;
        console.log('Fetched Portfolio Data:', this.portfolioDropdownOptions);
      },
      error: (err) => {
        this.ngxSpinnerService.hide();
        console.error('Error fetching portfolio data:', err);
        this.notificationsService.showNotification(this.transloco.translate('editprofile.error'), this.transloco.translate('editprofile.fetchPortfolioFailed'), NotificationTypes.Error);
      },
    });
  }

  public onPortfolioChange(event: any): void {
    console.log('Portfolio First selected:', event.value);
    const selectedPortfolioId = event.value;
    const selectedPortfolio = this.portfolioDropdownOptions.find(
      (portfolio) => portfolio.Id === selectedPortfolioId
    );
    if (selectedPortfolio) {
      this.portfolioSelection1.portfolioLinkId = selectedPortfolio.Id;
      this.portfolioSelection1.title = selectedPortfolio.Title;
      this.portfolioSelection1.description = selectedPortfolio.Description;
    } else {
      this.portfolioSelection1.portfolioLinkId = '';
      this.portfolioSelection1.title = '';
      this.portfolioSelection1.description = '';
    }
  }

  public onSecondPortfolioChange(event: any): void {
    console.log('Portfolio Second selected:', event.value);
    const selectedPortfolioId = event.value;
    const selectedPortfolio = this.portfolioDropdownOptions.find(
      (portfolio) => portfolio.Id === selectedPortfolioId
    );
    if (selectedPortfolio) {
      this.portfolioSelection2.portfolioLinkId = selectedPortfolio.Id;
      this.portfolioSelection2.title = selectedPortfolio.Title;
      this.portfolioSelection2.description = selectedPortfolio.Description;
    } else {
      this.portfolioSelection2.portfolioLinkId = '';
      this.portfolioSelection2.title = '';
      this.portfolioSelection2.description = '';
    }
  }

  public onThirdPortfolioChange(event: any): void {
    console.log('Portfolio Third selected:', event.value);
    const selectedPortfolioId = event.value;
    const selectedPortfolio = this.portfolioDropdownOptions.find(
      (portfolio) => portfolio.Id === selectedPortfolioId
    );
    if (selectedPortfolio) {
      this.portfolioSelection3.portfolioLinkId = selectedPortfolio.Id;
      this.portfolioSelection3.title = selectedPortfolio.Title;
      this.portfolioSelection3.description = selectedPortfolio.Description;
    } else {
      this.portfolioSelection3.portfolioLinkId = '';
      this.portfolioSelection3.title = '';
      this.portfolioSelection3.description = '';
    }
  }

  public onPortfolioCheckbox1($event: any) {
    console.log($event);
    this.portfolioSelection1.isShow = $event.checked;
  }

  public onPortfolioCheckbox2($event: any) {
    console.log($event);
    this.portfolioSelection2.isShow = $event.checked;
  }

  public onPortfolioCheckbox3($event: any) {
    console.log($event);
    this.portfolioSelection3.isShow = $event.checked;
  }

  // Save selected portfolios
  public savePortfolio(): void {
    const portfoliosToSave = [];
    if (this.portfolioSelection1.portfolioLinkId) {
      portfoliosToSave.push({
        portfolioLinkId: this.portfolioSelection1.portfolioLinkId,
        title: this.portfolioSelection1.title,
        description: this.portfolioSelection1.description,
        isShow: this.portfolioSelection1.isShow
      });
    }
    if (this.portfolioSelection2.portfolioLinkId) {
      portfoliosToSave.push({
        portfolioLinkId: this.portfolioSelection2.portfolioLinkId,
        title: this.portfolioSelection2.title,
        description: this.portfolioSelection2.description,
        isShow: this.portfolioSelection2.isShow
      });
    }
    if (this.portfolioSelection3.portfolioLinkId) {
      portfoliosToSave.push({
        portfolioLinkId: this.portfolioSelection3.portfolioLinkId,
        title: this.portfolioSelection3.title,
        description: this.portfolioSelection3.description,
        isShow: this.portfolioSelection3.isShow
      });
    }
    console.log(portfoliosToSave);
    if (portfoliosToSave.length === 0) {
      this.notificationsService.showNotification(this.transloco.translate('editprofile.warning'), this.transloco.translate('editprofile.selectAtLeastOnePortfolio'), NotificationTypes.Error);
      return;
    }
    this.ngxSpinnerService.show();
    this.artistPortfolioProductsService.saveFavoritePortfolio(portfoliosToSave).subscribe({
      next: (response: ResponseObject) => {
        this.ngxSpinnerService.hide();
        if (response.Success) {
          this.notificationsService.showNotification(this.transloco.translate('editprofile.success'), response.ResponseMessage || this.transloco.translate('editprofile.portfoliosSaved'), NotificationTypes.Success);
        } else {
          this.notificationsService.showNotification(this.transloco.translate('editprofile.error'), response.ResponseMessage || this.transloco.translate('editprofile.savePortfoliosFailed'), NotificationTypes.Error);
        }
      },
      error: (err) => {
        this.ngxSpinnerService.hide();
        console.error('Error saving portfolios:', err);
        this.notificationsService.showNotification(this.transloco.translate('editprofile.error'), this.transloco.translate('editprofile.savePortfoliosError'), NotificationTypes.Error);
      },
    });
  }

  public previewPortfolio(portfolioId: string): void {
    this.selectedPortfolioId = portfolioId;
    this.showportfoliosproductsdialog = true;
  }

  public closeshowportfoliosproductsdialog() {
    this.showportfoliosproductsdialog = false;
  }

  // Generate Wix plugin key
  public onGeneratePluginKey(): void {
    this.ngxSpinnerService.show();
    this.wixService.generatePluginKey().subscribe(
      (response: ResponseObject) => {
        this.getUserById();
        this.ngxSpinnerService.hide();
        if (response.Success) {
          this.notificationsService.showNotification(this.transloco.translate('editprofile.success'), this.transloco.translate('editprofile.pluginKeyGenerated'), NotificationTypes.Success);
          console.log('Generated Plugin Key:', response.ResponseMessage);
        } else {
          this.notificationsService.showNotification(this.transloco.translate('editprofile.error'), response.ResponseMessage, NotificationTypes.Error);
        }
      },
      (error) => {
        this.ngxSpinnerService.hide();
        console.error('Error generating plugin key:', error);
        this.notificationsService.showNotification(this.transloco.translate('editprofile.error'), this.transloco.translate('editprofile.generatePluginKeyFailed'), NotificationTypes.Error);
      }
    );
  }

  public onDeclinePluginKey(): void {
    this.ngxSpinnerService.show();
    this.wixService.declinePluginKey().subscribe(
      (response: ResponseObject) => {
        this.getUserById();
        this.ngxSpinnerService.hide();
        if (response.Success) {
          this.notificationsService.showNotification(this.transloco.translate('editprofile.success'), this.transloco.translate('editprofile.pluginKeyDeclined'), NotificationTypes.Success);
          console.log('Declined Plugin Key:', response.ResponseMessage);
        } else {
          this.notificationsService.showNotification(this.transloco.translate('editprofile.error'), response.ResponseMessage, NotificationTypes.Error);
        }
      },
      (error) => {
        this.ngxSpinnerService.hide();
        console.error('Error declining plugin key:', error);
        this.notificationsService.showNotification(this.transloco.translate('editprofile.error'), this.transloco.translate('editprofile.declinePluginKeyFailed'), NotificationTypes.Error);
      }
    );
  }

  public copyToClipboard(text: string): void {
    if (!text) {
      console.error('No text provided to copy.');
      return;
    }
    navigator.clipboard.writeText(text).then(() => {
      console.log('Text copied to clipboard:', text);
      this.notificationsService.showNotification(
        this.transloco.translate('editprofile.success'),
        this.transloco.translate('editprofile.pluginKeyCopied'),
        NotificationTypes.Success
      );
    }).catch(err => {
      console.error('Failed to copy text to clipboard:', err);
      this.notificationsService.showNotification(
        this.transloco.translate('editprofile.error'),
        this.transloco.translate('editprofile.copyPluginKeyFailed'),
        NotificationTypes.Error
      );
    });
  }

  // Handle primary art type change
  public onPrimaryArtTypeChange(newPrimaryArtTypeId: string): void {
    const previousPrimaryArtTypeId = this.formData.PrimaryArtTypeId;
    this.formData.PrimaryArtTypeId = newPrimaryArtTypeId;
    if (previousPrimaryArtTypeId && this.selectedArtTypes.includes(previousPrimaryArtTypeId)) {
      this.selectedArtTypes = this.selectedArtTypes.filter(id => id !== previousPrimaryArtTypeId);
    }
    if (this.selectedArtTypes.includes(newPrimaryArtTypeId)) {
      this.selectedArtTypes = this.selectedArtTypes.filter(id => id !== newPrimaryArtTypeId);
    }
  }

  // Filter art types excluding primary art type
  get filteredArtTypes() {
    if (!this.formData.PrimaryArtTypeId) {
      return this.artTypes;
    }
    return this.artTypes.filter(a => a.value !== this.formData.PrimaryArtTypeId);
  }

  public openShareDialog(): void {
    this.showShareDialog = true;
  }

  public onShareDialogClose($event: boolean) {
    this.showShareDialog = $event;
  }

  public ConnectCanvaAccount() {
    this.router.navigate(['/connect-with-canva-account']);
  }

  // Fetch selected gallery art types
  private getSelectedGalleryArtTypes() {
    this.galleriesService.getGalleryArtTypes().subscribe({
      next: (response: any) => {
        let selectedArtTypeIds: string[] = [];
        if (Array.isArray(response)) {
          selectedArtTypeIds = response;
        } else if (response && Array.isArray(response.data)) {
          selectedArtTypeIds = response.data;
        } else if (response && Array.isArray(response.GalleryArtTypesDTOs)) {
          selectedArtTypeIds = response.GalleryArtTypesDTOs.map((item: any) => item.Id || item.id);
        } else {
          console.warn('Unexpected response format for gallery art types:', response);
        }
        this.selectedGalleryArtTypes = selectedArtTypeIds || [];
        console.log('Selected Gallery Art Types:', this.selectedGalleryArtTypes);
      },
      error: (error) => {
        console.error('Error fetching gallery art types:', error);
        this.selectedGalleryArtTypes = [];
        this.notificationsService.showNotification(this.transloco.translate('editprofile.error'), this.transloco.translate('editprofile.fetchGalleryArtTypesFailed'), NotificationTypes.Error);
      }
    });
  }

  public onGalleryArtTypeChange(event: any): void {
    const selectedCount = this.selectedGalleryArtTypes.length;
    if (this.isFreePlanUser && (this.hasFreeTrailEnded || !this.isOnFreeTrial) && selectedCount > this.numberOfArtTypeSelection) {
      this.selectedGalleryArtTypes.pop();
      this.upgradeDialogVisible = true;
      this.notificationsService.showNotification(this.transloco.translate('editprofile.warning'), this.transloco.translate('editprofile.upgradeToProArtTypes'), NotificationTypes.Error);
    }
  }

  // Save gallery art types
  public saveGalleryArtTypes() {
    console.log('selectedGalleryArtTypes', this.selectedGalleryArtTypes);
    if (this.selectedGalleryArtTypes.length === 0) {
      this.notificationsService.showNotification(this.transloco.translate('editprofile.warning'), this.transloco.translate('editprofile.selectAtLeastOneArtType'), NotificationTypes.Error);
      return;
    }
    this.ngxSpinnerService.show();
    this.galleriesService.saveGalleryArtTypes(this.selectedGalleryArtTypes).subscribe({
      next: (response: ResponseObject) => {
        this.ngxSpinnerService.hide();
        if (response.Success) {
          this.notificationsService.showNotification(this.transloco.translate('editprofile.success'), this.transloco.translate('editprofile.galleryArtTypesSaved'), NotificationTypes.Success);
        } else {
          this.notificationsService.showNotification(this.transloco.translate('editprofile.error'), response.ResponseMessage || this.transloco.translate('editprofile.saveGalleryArtTypesFailed'), NotificationTypes.Error);
        }
      },
      error: (error) => {
        console.error('Error saving gallery art types:', error);
        this.ngxSpinnerService.hide();
        this.notificationsService.showNotification(this.transloco.translate('editprofile.error'), this.transloco.translate('editprofile.saveGalleryArtTypesFailed'), NotificationTypes.Error);
      }
    });
  }

  public getArtTypeLabelById(artTypeId: string): string {
    const artType = this.artTypes.find(type => type.value === artTypeId);
    return artType?.label ?? 'Unknown';
  }


  public getGalleryById(galleryId: string) {
    this.ngxSpinnerService.show();
    this.galleriesService.fetchById(galleryId).subscribe({
      next: (gallery) => {
        if (!gallery) {
          // Handle case where gallery is null
          this.galleryItems = new GalleryItems();
          this.galleryItems.PaymentTerms = '';
          this.galleryItems.ReturnPolicy = '';
          this.galleryItems.TermsConditions = '';
          this.documents = [];
          this.ngxSpinnerService.hide();
          return;
        }

        this.galleryItems = gallery;

        if (gallery.GalleryTermsHistroyDTO) {
          this.galleryItems.PaymentTerms = gallery.GalleryTermsHistroyDTO.PaymentTerms || '';
          this.galleryItems.ReturnPolicy = gallery.GalleryTermsHistroyDTO.ReturnPolicy || '';
          this.galleryItems.TermsConditions = gallery.GalleryTermsHistroyDTO.TermsConditions || '';
          if (gallery.GalleryTermsHistroyDTO.GalleryDocumentDTOs) {
            this.documents = gallery.GalleryTermsHistroyDTO.GalleryDocumentDTOs.map(doc => ({
              Id: doc.Id,
              DocumentName: doc.DocumentName,
              FilePath: doc.DocumentUrl,
              UploadedAt: doc.UploadedAt ? new Date(doc.UploadedAt) : new Date(),
              DocumentType: this.mapSectionToDocumentType(doc.Section),
              UserId: galleryId,
              Section: doc.Section
            }));
          }
        } else {
          this.galleryItems.PaymentTerms = '';
          this.galleryItems.ReturnPolicy = '';
          this.galleryItems.TermsConditions = '';
          this.documents = [];
        }

        this.ngxSpinnerService.hide();
      },
      error: (error) => {
        console.error('Error fetching gallery:', error);
        this.ngxSpinnerService.hide();
        this.notificationsService.showNotification(this.transloco.translate('editprofile.error'), this.transloco.translate('editprofile.loadGalleryFailed'), NotificationTypes.Error);
      }
    });
  }


  private mapSectionToDocumentType(section: GalleryDocumentSectionEnum): string {
    switch (section) {
      case GalleryDocumentSectionEnum.PaymentTerms: return 'PaymentTerms';
      case GalleryDocumentSectionEnum.ReturnPolicy: return 'ReturnPolicy';
      case GalleryDocumentSectionEnum.TermsConditions: return 'TermsConditions';
      default: return 'PaymentTerms';
    }
  }

  public hasDocument(documentType: string): boolean {
    return this.documents.some(doc => doc.DocumentType === documentType);
  }

  public getDocument(documentType: string): UserDocumentDTOs | undefined {
    return this.documents.find(doc => doc.DocumentType === documentType);
  }

  public onDocumentSelected(event: any, documentType: string): void {
    const files: File[] = event.files;
    if (!files || files.length === 0) {
      this.notificationsService.showNotification(this.transloco.translate('editprofile.error'), this.transloco.translate('editprofile.noFileSelected'), NotificationTypes.Error);
      return;
    }
    const file = files[0];
    if (!['application/pdf', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'].includes(file.type)) {
      this.notificationsService.showNotification(this.transloco.translate('editprofile.error'), this.transloco.translate('editprofile.onlyPdfDocxAllowed'), NotificationTypes.Error);
      this.clearFileUpload(documentType);
      return;
    }
    if (file.size > 10000000) {
      this.notificationsService.showNotification(this.transloco.translate('editprofile.error'), this.transloco.translate('editprofile.fileSizeExceeds'), NotificationTypes.Error);
      this.clearFileUpload(documentType);
      return;
    }
    this.selectedFiles[documentType] = file.name;
    this.documentToRename = {
      isExisting: false,
      file: file,
      documentType: documentType,
      originalName: file.name
    };
    this.newDocumentName = file.name.replace(/\.[^/.]+$/, '') || `${documentType}_${Date.now()}`;
    this.isRenameDialogVisible = true;
  }

  // Save document and gallery terms
  public saveDocumentAndTerms(): void {
    if (!this.documentToRename || !this.documentToRename.file || !this.documentToRename.documentType) {
      this.notificationsService.showNotification(this.transloco.translate('editprofile.error'), this.transloco.translate('editprofile.invalidDocumentData'), NotificationTypes.Error);
      this.isRenameDialogVisible = false;
      return;
    }
    if (!this.newDocumentName || this.newDocumentName.trim() === '') {
      this.newDocumentName = `${this.documentToRename.documentType}_${Date.now()}`;
      this.notificationsService.showNotification(this.transloco.translate('editprofile.warning'), this.transloco.translate('editprofile.noDocumentName'), NotificationTypes.Error);
    }
    const documentType = this.documentToRename.documentType;
    const termsData: GalleryTermsData = {
      paymentTerms: this.galleryItems.PaymentTerms?.trim() || '',
      returnPolicy: this.galleryItems.ReturnPolicy?.trim() || '',
      termsConditions: this.galleryItems.TermsConditions?.trim() || ''
    };
    this.isUploading = true;
    this.ngxSpinnerService.show();
    const file = this.documentToRename.file;
    this.uploadService.uploadIFile(file).subscribe({
      next: (response: any) => {
        const attachRequest: AttachDocumentRequest = {
          section: this.getDocumentSectionEnum(documentType),
          documentName: this.newDocumentName.trim(),
          documentUrl: response.FileUrl
        };
        this.attachDocumentToGallery(attachRequest, documentType, termsData);
      },
      error: (error) => {
        console.error('Error uploading document:', error);
        this.isUploading = false;
        this.ngxSpinnerService.hide();
        this.notificationsService.showNotification(this.transloco.translate('editprofile.error'), this.transloco.translate('editprofile.uploadDocumentFailed'), NotificationTypes.Error);
        this.isRenameDialogVisible = false;
        this.documentToRename = null;
        this.newDocumentName = '';
      }
    });
  }

  private getDocumentSectionEnum(documentType: string): GalleryDocumentSectionEnum {
    switch (documentType) {
      case 'PaymentTerms': return GalleryDocumentSectionEnum.PaymentTerms;
      case 'ReturnPolicy': return GalleryDocumentSectionEnum.ReturnPolicy;
      case 'TermsConditions': return GalleryDocumentSectionEnum.TermsConditions;
      default: return GalleryDocumentSectionEnum.PaymentTerms;
    }
  }

  private attachDocumentToGallery(attachRequest: AttachDocumentRequest, documentType: string, termsData: GalleryTermsData): void {
    this.galleriesService.attachGalleryDocument(attachRequest).subscribe({
      next: (response: ResponseObject) => {
        if (response.Success) {
          this.notificationsService.showNotification(this.transloco.translate('editprofile.success'), this.transloco.translate('editprofile.documentUploaded'), NotificationTypes.Success);
          this.getGalleryById(this.userId);
          delete this.selectedFiles[documentType];
        } else {
          this.notificationsService.showNotification(this.transloco.translate('editprofile.error'), response.ResponseMessage || this.transloco.translate('editprofile.uploadDocumentFailed'), NotificationTypes.Error);
        }
      },
      error: (error) => {
        console.error('Error attaching document:', error);
        this.notificationsService.showNotification(this.transloco.translate('editprofile.error'), this.transloco.translate('editprofile.uploadDocumentFailed'), NotificationTypes.Error);
      },
      complete: () => {
        this.isUploading = false;
        this.ngxSpinnerService.hide();
        this.isRenameDialogVisible = false;
        this.documentToRename = null;
        this.newDocumentName = '';
      }
    });
  }

  public clearFileUpload(documentType: string): void {
    delete this.selectedFiles[documentType];
    switch (documentType) {
      case 'PaymentTerms':
        this.paymentTermsFileUpload?.clear();
        break;
      case 'ReturnPolicy':
        this.returnPolicyFileUpload?.clear();
        break;
      case 'TermsConditions':
        this.termsConditionsFileUpload?.clear();
        break;
    }
  }

  public cancelDocumentRename(): void {
    if (this.documentToRename && !this.documentToRename.isExisting) {
      this.clearFileUpload(this.documentToRename.documentType);
    }
    this.isRenameDialogVisible = false;
    this.documentToRename = null;
    this.newDocumentName = '';
  }

  public downloadDocument(filePath: string, documentName: string): void {
    if (!filePath || !documentName) {
      this.notificationsService.showNotification(this.transloco.translate('editprofile.error'), this.transloco.translate('editprofile.cannotDownloadInvalidPath'), NotificationTypes.Error);
      return;
    }
    fetch(filePath)
      .then(res => res.blob())
      .then(blob => {
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl, '_blank');
        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = documentName;
        a.click();
        setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
      })
      .catch(err => {
        console.error('Error downloading document:', err);
        this.notificationsService.showNotification(this.transloco.translate('editprofile.error'), this.transloco.translate('editprofile.downloadDocumentFailed'), NotificationTypes.Error);
      });
  }

  public deleteDocument(documentId: string, documentName: string, documentType: string): void {
    if (!documentId || !documentName) {
      this.notificationsService.showNotification(this.transloco.translate('editprofile.error'), this.transloco.translate('editprofile.cannotDeleteInvalidId'), NotificationTypes.Error);
      return;
    }
    this.confirmationService.confirm({
      message: this.transloco.translate('editprofile.deleteDocumentConfirm', { documentName: documentName }),
      header: this.transloco.translate('editprofile.confirmDeletion'),
      icon: 'pi pi-exclamation-triangle',
      acceptButtonStyleClass: 'p-button-danger',
      rejectButtonStyleClass: 'p-button-secondary',
      accept: () => {
        this.ngxSpinnerService.show();
        this.galleriesService.deleteGalleryDocument(documentId).subscribe({
          next: (response: ResponseObject) => {
            this.ngxSpinnerService.hide();
            if (response.Success) {
              this.documents = this.documents.filter(doc => doc.Id !== documentId);
              this.notificationsService.showNotification(this.transloco.translate('editprofile.success'), this.transloco.translate('editprofile.documentDeleted'), NotificationTypes.Success);
            } else {
              this.notificationsService.showNotification(this.transloco.translate('editprofile.error'), response.ResponseMessage || this.transloco.translate('editprofile.deleteDocumentFailed'), NotificationTypes.Error);
            }
          },
          error: (err) => {
            console.error('Error deleting document:', err);
            this.ngxSpinnerService.hide();
            this.notificationsService.showNotification(this.transloco.translate('editprofile.error'), this.transloco.translate('editprofile.deleteDocumentFailed'), NotificationTypes.Error);
          }
        });
      }
    });
  }

  // Save gallery terms and documents
  public saveGalleryTerms(termsData?: GalleryTermsData): void {
    if (!this.userId) {
      this.notificationsService.showNotification(this.transloco.translate('editprofile.error'), this.transloco.translate('editprofile.userIdMissing'), NotificationTypes.Error);
      return;
    }
    const terms: GalleryTermsData = termsData || {
      paymentTerms: this.galleryItems.PaymentTerms?.trim() || '',
      returnPolicy: this.galleryItems.ReturnPolicy?.trim() || '',
      termsConditions: this.galleryItems.TermsConditions?.trim() || ''
    };
    if (!terms.paymentTerms && !terms.returnPolicy && !terms.termsConditions && !Object.keys(this.selectedFiles).length) {
      this.notificationsService.showNotification(this.transloco.translate('editprofile.warning'), this.transloco.translate('editprofile.noTermsOrDocuments'), NotificationTypes.Error);
      this.ngxSpinnerService.hide();
      return;
    }
    this.isUploading = true;
    this.ngxSpinnerService.show();
    this.galleriesService.saveGalleryTermsDocuments(terms).subscribe({
      next: (response: ResponseObject) => {
        if (response.Success) {
          this.notificationsService.showNotification(this.transloco.translate('editprofile.success'), this.transloco.translate('editprofile.termsSaved'), NotificationTypes.Success);
          this.getGalleryById(this.userId);
        } else {
          this.notificationsService.showNotification(this.transloco.translate('editprofile.error'), response.ResponseMessage || this.transloco.translate('editprofile.saveTermsFailed'), NotificationTypes.Error);
        }
      },
      error: (error) => {
        console.error('Error saving terms:', error);
        this.notificationsService.showNotification(this.transloco.translate('editprofile.error'), this.transloco.translate('editprofile.saveTermsFailed'), NotificationTypes.Error);
      },
      complete: () => {
        this.isUploading = false;
        this.ngxSpinnerService.hide();
      }
    });
  }
}

export class ResetPassword {
  UserId!: string;
  CurrentPassword!: string;
  NewPassword!: string;
  ConfirmPassword!: string;
}